module.exports = __webpack_public_path__ + "img/shared3.6d989bd4.png";